<template>
  <div>
    <div v-if="loadingStalled"></div>
    <v-card :loading="loading" outlined>
      <v-card-title class="subtitle-2"> Crop Details </v-card-title>
      <v-card-subtitle class="caption font-italic">
        (conatins last two or less data points when crops were modified)
      </v-card-subtitle>
      <v-divider></v-divider>
      <v-container fluid>
        <v-row
          align-content="center"
          justify="center"
          v-if="cropDetails.length > 0"
        >
          <v-col
            cols="12"
            sm="12"
            md="6"
            v-for="cropDetail in cropDetails"
            :key="cropDetail.timestamp"
          >
            <v-card outlined>
              <v-card-title class="body-2">
                Crops changed on {{ dateFormat24hr(cropDetail.timestamp) }}
              </v-card-title>
              <v-card-subtitle> </v-card-subtitle>
              <v-divider />
              <v-card-text>
                <v-container fluid>
                  <v-row align-content="space-around" justify="space-around">
                    <v-col cols="6">
                      <span class="font-weight-black"> Set Temp: </span>
                      {{
                        cropDetail.setTemperature === 'N/A'
                          ? 'N/A'
                          : `${parseFloat(cropDetail.setTemperature).toFixed(
                              2
                            )}°C`
                      }}
                    </v-col>
                    <v-col cols="6">
                      <span class="font-weight-black">R1 Temp: </span>
                      {{
                        cropDetail.room1Temperature === 'N/A'
                          ? 'N/A'
                          : `${parseFloat(cropDetail.room1Temperature).toFixed(
                              2
                            )}°C`
                      }}
                    </v-col>
                  </v-row>
                </v-container>
                <v-container
                  v-if="cropDetail.crops.length === 0"
                  class="text-center"
                >
                  No crops present in this machine
                </v-container>
                <v-simple-table dense fixed-header v-else>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Type</th>
                        <th>Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="crop in cropDetail.crops" :key="crop.crop">
                        <td>{{ crop.crop }}</td>
                        <td>{{ crop.commodityType }}</td>
                        <td>{{ crop.cropMeasurement }} {{ crop.cropUnit }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row align-content="center" justify="center" v-else>
          <v-col cols="12" sm="12" md="6" class="text-center">
            No crops have been added to this machine
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import { dateFormat24hr } from '../plugins/date';
import { nodeRestApi } from '../plugins/api';
export default {
  name: 'crop-details',
  props: {
    deviceId: {
      type: String,
      require: true
    },
    from: {
      type: String,
      required: true
    },
    to: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      cropDetails: [],
      loading: true,
      loadingStalled: false
    };
  },
  computed: {},
  methods: {
    dateFormat24hr,
    async updateCropDetails() {
      try {
        this.loading = true;
        const response = await nodeRestApi.post(
          `ecofrost/crop-details/${this.deviceId}`,
          { limit: 2 }
        );
        this.cropDetails = response.data;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.loadingStalled = true;
        if (error.response.data.error.message) {
          this.$store.commit('setError', error.response.data.error.message);
        } else {
          this.$store.commit('setError', error.response.data.error);
        }
      }
    }
  },
  async created() {
    try {
      this.loadingStalled = false;
      this.loading = true;
      const response = await nodeRestApi.post(
        `ecofrost/crop-details/${this.deviceId}`,
        { limit: 2 }
      );
      this.cropDetails = response.data;

      this.loading = false;
    } catch (error) {
      this.loading = false;
      this.loadingStalled = true;
      if (error.response.data.error.message) {
        this.$store.commit('setError', error.response.data.error.message);
      } else {
        this.$store.commit('setError', error.response.data.error);
      }
    }
  }
};
</script>
